<template>
  <!-- starting div -->
  <div
    id="page-content"
    class="customer-create-page"
    style="padding-bottom:180px;margin-top:-10px;"
  >
    <!-- section 1 :page title for customer update -->
    <GlobalHeader title="Customer" @redirectPage="redirectPage"></GlobalHeader>
    <!-- section 2 : error validation block  -->
    <b-row class="mt-2 px-pad">
      <b-col xl="12" lg="12" md="12" xs="12" sm="12" class="px-0">
        <div class="container-fluid">
          <b-alert class="alert-transparent alert-danger" :show="error_show && this.errors.any()">
            <button type="button" @click="error_show = !error_show" class="close">
              <span aria-hidden="true">&times;</span>
            </button>
            <div v-for="item in errors.items" :key="item.id" v-if="item.scope == 'customer-form'">
              <p class="fw-semi-bold">{{ item.msg }}</p>
            </div>
          </b-alert>
        </div>
      </b-col>
    </b-row>
    <b-form
      class="mt-3 pt-1"
      @submit.prevent="onSubmit('customer-form')"
      id="customer_form"
      data-vv-scope="customer-form"
      style="margin-left:3px;margin-right:3px;"
    >
      <b-row style="max-width:1000px;">
        <b-col cols="12" lg="5" md="6" sm="8">
          <b-form-group class="mb-3" label="Customer ID" label-for="cus_legacy_id">
            <b-form-input
              type="text"
              data-vv-name="customer id"
              name="cus_legacy_id"
              size="sm"
              v-model.trim="field.cus_legacy_id"
              v-validate="'max:50|min:3'"
            />
          </b-form-group>
        </b-col>
        <b-col cols="12" lg="5" md="6" sm="8">
          <!-- <legend>Basic Details</legend> -->
          <b-form-group
            horizontal
            :label-cols="4"
            class="mb-3 mt-4"
            label="Customer Type"
            label-for="cus_type"
          >
            <b-form-radio-group
              class="mt-1"
              @input="
                field.cus_display_name =
                  field.cus_type == 2
                    ? field.cus_comp
                    : field.cus_fname + ' ' + field.cus_lname
              "
              id="customer_type"
              name="cus_type"
              data-vv-name="customer type"
              v-model.trim="field.cus_type"
              :options="cus_type"
            />
          </b-form-group>
        </b-col>
      </b-row>

      <!-- customer names for customer update cus_name()-->
      <b-row style="max-width:1000px;">
        <b-col cols="12" lg="5" md="6" sm="8">
          <b-form-group
            :label-class="field.cus_type == 1 ? 'required' : ''"
            :label="field.cus_type == 1 ? 'First Name' : 'First Name'"
            label-for="cus_fname"
            class="mb-3"
          >
            <b-form-input
              @input="
                field.cus_display_name =
                  field.cus_type == 2
                    ? field.cus_comp
                    : field.cus_fname
              "
              id="cus_fname"
              type="text"
              size="sm"
              v-model.trim="field.cus_fname"
              v-validate="
                field.cus_type == 1 ? 'required|min:3|max:30' : 'min:3|max:30'
              "
              name="cus_fname"
              data-vv-name="first name"
            />
          </b-form-group>
        </b-col>

        <b-col cols="12" lg="5" md="6" sm="8">
          <b-form-group label="Last Name" label-for="cus_lname" class="mb-3">
            <b-form-input
              @input="
                field.cus_display_name =
                  field.cus_type == 2
                    ? field.cus_comp
                    : field.cus_fname + ' ' + field.cus_lname
              "
              type="text"
              size="sm"
              name="cus_lname"
              data-vv-name="last name"
              v-model.trim="field.cus_lname"
              v-validate="'min:1|max:30'"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <!-- End customer names for customer update cus_comp_name()-->
      <!-- customer company and display name for customer update -->
      <b-row style="max-width:1000px;">
        <b-col cols="12" lg="5" md="6" sm="8">
          <b-form-group
            class="mb-3"
            :label-class="field.cus_type == 2 ? 'required' : ''"
            label="Company Name"
            label-for="comp_name"
          >
            <b-form-input
              @input="
                field.cus_display_name =
                  field.cus_type == 2
                    ? field.cus_comp
                    : field.cus_fname + ' ' + field.cus_lname
              "
              type="text"
              size="sm"
              name="cus_comp"
              v-validate="
                field.cus_type == 2 ? 'required|min:3|max:150' : 'min:3|max:150'
              "
              v-model.trim="field.cus_comp"
              data-vv-name="company name"
            />
          </b-form-group>
        </b-col>
        <b-col cols="12" lg="5" md="6" sm="8">
          <b-form-group
            label-class="required"
            class="mb-3"
            label="Display Name"
            label-for="cus_display_name"
          >
            <b-form-input
              type="text"
              id="dis_name"
              name="cus_display_name"
              data-vv-name="display name"
              v-model.trim="field.cus_display_name"
              size="sm"
              v-validate="'required|max:150|min:3'"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <!-- End customer company and display name for customer update -->

      <!--  Email and Phone no for customer update -->

      <b-row style="max-width:1000px;">
        <b-col cols="12" lg="5" md="6" sm="8">
          <b-form-group label="Email Id" label-for="cus_mail" class="mb-3">
            <b-form-input
              type="text"
              size="sm"
              id="cus_mail"
              v-model.trim="field.cus_mail"
              name="cus_mail"
              data-vv-name="email"
              v-validate="'email'"
            />
          </b-form-group>
        </b-col>

        <b-col
          cols="12"
          lg="5"
          md="6"
          sm="8"
          v-if="org_details.gst_type == 1 && field.cus_gst_type!=6"
        >
          <b-form-group
            :label="'Place of Supply'"
            label-class="required"
            class="mb-3"
            label-for="place_of_supply"
          >
            <v-select
              :disabled="
              field.place_of_supply == '97'"
              :clearable="false"
              data-vv-name="place of supply"
              name="place_of_supply"
              id="search-select"
              v-model.trim="field.place_of_supply"
              v-validate="'required'"
              size="sm"
              index="state_id"
              label="state_name"
              :options="$AppDetails.state_list"
            />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row
        style="max-width:1000px;"
        class="mt-3"
        v-if="field.cus_type == 2 && org_details.gst_type == 1"
      >
        <b-col cols="12" lg="5" md="6" sm="8">
          <b-form-group
            class="mb-3"
            :label="'GST Treatment'"
            label-class="required"
            label-for="cus_gst_type"
          >
            <v-select
              :clearable="false"
              id="search-select"
              v-model.trim="field.cus_gst_type"
              name="gst_treatment"
              index="gst_type_id"
              label="gst_type_name"
              v-validate="'required'"
              data-vv-name="gst treatment"
              size="sm"
              :options="$AppDetails.gst_type_list"
              @input="
                $event == '6'
                  ? ((field.place_of_supply = '97'),
                    (field.exempt_reason = ''),
                    (field.cus_tax_exempt = 0))
                  : field.place_of_supply == '97'
                  ? (field.place_of_supply = org_details.org_state)
                  : (field.place_of_supply = field.place_of_supply)
              "
            />
          </b-form-group>
        </b-col>
        <b-col cols="12" lg="5" md="6" sm="8" v-if="checkgsttype">
          <b-form-group
            class="mb-3"
            :label="'Gst No'"
            label-class="required"
            label-for="cus_gst_no"
          >
            <b-form-input
              type="text"
              name="Customer GST"
              data-vv-name="gst no"
              size="sm"
              class="form-control"
              :formatter="inputUpper"
              @input="getPanState(field.cus_gst_no)"
              v-model.trim="field.cus_gst_no"
              v-validate=" { required:true,regex:checkgsttype && field.cus_gst_type != '8' ?/^([0][1-9]|[1-2][0-9]|[3][0-7])([A-Z]{5})([0-9]{4})([A-Z]{1}[1-9A-Z]{1})([Z]{1})([0-9A-Z]{1})+$/:/^([0][1-9]|[1-2][0-9]|[3][0-7])([A-Z]{5})([0-9]{4})([A-Z]{1}[1-9A-Z]{1})([D]{1})([0-9A-Z]{1})+$/,max:15 }"
            />
          </b-form-group>
        </b-col>
        <b-col cols="12" lg="5" md="6" sm="8">
          <b-form-group horizontal label="Pan No" label-for="cus_pan_no" class="mb-3">
            <b-form-input
              type="text"
              name="Customer Pan number"
              data-vv-name="pan no"
              size="sm"
              :formatter="inputUpper"
              v-model.trim="field.cus_pan_no"
              v-validate="{
                regex: /^([A-Z]{5})([0-9]{4})([A-Z]{1})+$/,
                max: 10,
              }"
            />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row style="max-width:1000px;">
        <b-col cols="6" lg="3" md="5" sm="6" class="pr-2">
          <b-form-group
            :label="'Phone No'"
            label-class="required"
            label-for="phone_no"
            class="mb-2"
          >
            <b-form-input
              type="text"
              id="cus_ph_no_1"
              name="Phone-Number"
              data-vv-name="phone number"
              size="sm"
              v-model.trim="field.cus_ph_no_1"
              v-validate="'required: true|phone'"
            />
          </b-form-group>
        </b-col>
        <b-col cols="6" lg="5" md="5" sm="6" class="mt-4 pt-2 pl-2">
          <b-form-group label=" " label-for="checkbox_is_whatsapp_no" class="mb-3">
            <b-form-checkbox
              v-model="field.is_whatsapp_no"
              :value="1"
              :unchecked-value="0"
              type="checkbox"
              id="is_whatsapp_no"
              name="is_whatsapp_no"
              data-vv-name="whatsapp number"
              class="mr-2 cursor_pointer"
            >Is WhatsApp No ?</b-form-checkbox>
          </b-form-group>
        </b-col>
      </b-row>
      <!-- End Email and Phone no for customer update -->
      <!-- Whatsapp number checkbox for customer update -->
      <b-row style="max-width:1000px" class="mt-4 mb-2 pt-2">
        <b-col>
          <h6
            class="text-primary pr-2 py-2 fw-semi-bold cursor_pointer h6-lg"
            v-b-toggle.other-details
          >
            Other details
            <i class="fa fa-angle-down fw-semi-bold ml-1"></i>
          </h6>
        </b-col>
      </b-row>
      <b-collapse id="other-details" visible>
        <!--  GST Treatment and currency for customer update -->
        <b-row style="max-width:1000px;">
          <b-col
            cols="12"
            lg="5"
            md="6"
            sm="8"
            v-if="org_details.gst_type == 1 && field.cus_gst_type != 6"
          >
            <b-form-group
              label="Tax Preference"
              label-for="tax_prefernce"
              horizontal
              :label-cols="4"
              class="mb-3"
            >
              <b-form-radio-group
                class="mt-1"
                id="customer_tax_exempt"
                name="cus_tax_exempt"
                data-vv-name="tax exempt"
                v-model="field.cus_tax_exempt"
                :options="taxable_preference"
                @input="field.exempt_reason = ''"
              />
            </b-form-group>
          </b-col>

          <b-col
            cols="12"
            lg="5"
            md="6"
            sm="8"
            v-if="field.cus_tax_exempt == 1 && field.cus_gst_type != 6"
          >
            <b-form-group
              class="mb-3"
              label-class="required"
              label="Exempt Reason"
              label-for="exempt_reason"
            >
              <b-input-group class="vselect-custom-add">
                <template slot="append">
                  <b-input-group-text
                    class="vselect-custom-add-icon"
                    v-b-tooltip
                    title="Add Exempt"
                    v-on:click="
                      (excemptmodal = true),
                        callexemptmodal({ value: '', label: '' })
                    "
                  >&#43;</b-input-group-text>
                </template>
                <template slot="prepend">
                  <v-select
                    :clearable="false"
                    data-vv-name="exempt reason"
                    size="sm"
                    :options="exempt_reason_list"
                    label="label"
                    index="value"
                    name="exempt_reason"
                    v-validate="'required'"
                    v-model.trim="field.exempt_reason"
                    class="form-vselect"
                  >
                    <template slot="option" slot-scope="option">
                      <div class="d-flex w-100 v-select-option" :title="option.label">
                        <div class="text-truncate" style="width:292px">{{ option.label }}</div>
                        <span class="select-hover-block">
                          <span
                            class="la la-edit la-lg float-right mr-2"
                            v-on:click.stop="
                              (excemptmodal = true),
                                callexemptmodal({
                                  value: option.value,
                                  label: option.label,
                                })
                            "
                          ></span>
                          <span
                            class="fa fa-trash-o fa-lg float-right mt-2p"
                            v-on:click.stop="
                              (excemptdelete = true),
                                (method = 'exemptdelete'),
                                calldeletemodal(option.value)
                            "
                          ></span>
                        </span>
                      </div>
                    </template>
                  </v-select>
                </template>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row style="max-width:1000px;" v-if="field.cus_type == 1 && org_details.gst_type == 1">
          <b-col cols="12" lg="5" md="6" sm="8">
            <b-form-group
              :label="'GST Treatment'"
              class="mb-3"
              label-class="required"
              label-for="cus_gst_type"
            >
              <v-select
                :clearable="false"
                id="search-select"
                v-model.trim="field.cus_gst_type"
                name="gst_treatment"
                data-vv-name="gst treatment"
                v-validate="'required'"
                index="gst_type_id"
                label="gst_type_name"
                size="sm"
                :options="$AppDetails.gst_type_list"
                @input="
                  $event == '6'
                    ? ((field.place_of_supply = '97'),
                      (field.exempt_reason = ''),
                      (field.cus_tax_exempt = 0))
                    : field.place_of_supply == '97'
                    ? (field.place_of_supply = org_details.org_state)
                    : (field.place_of_supply = field.place_of_supply)
                "
              />
            </b-form-group>
          </b-col>
          <b-col cols="12" lg="5" md="6" sm="8" v-if="checkgsttype">
            <b-form-group
              :label="'GST No'"
              class="mb-3"
              label-class="required"
              label-for="cus_gst_no"
            >
              <b-form-input
                type="text"
                data-vv-name="gst no"
                name="Customer GST"
                size="sm"
                class="form-control"
                :formatter="inputUpper"
                @input="getPanState(field.cus_gst_no)"
                v-model.trim="field.cus_gst_no"
                v-validate=" { required:true,regex:checkgsttype && field.cus_gst_type != '8' ?/^([0][1-9]|[1-2][0-9]|[3][0-7])([A-Z]{5})([0-9]{4})([A-Z]{1}[1-9A-Z]{1})([Z]{1})([0-9A-Z]{1})+$/:/^([0][1-9]|[1-2][0-9]|[3][0-7])([A-Z]{5})([0-9]{4})([A-Z]{1}[1-9A-Z]{1})([D]{1})([0-9A-Z]{1})+$/,max:15 }"
              />
            </b-form-group>
          </b-col>
          <b-col cols="12" lg="5" md="6" sm="8">
            <b-form-group label="Pan No" label-for="cus_pan_no" class="mb-3">
              <b-form-input
                type="text"
                data-vv-name="pan no"
                name="Customer Pan number"
                :formatter="inputUpper"
                size="sm"
                v-model.trim="field.cus_pan_no"
                v-validate="{
                  regex: /^([A-Z]{5})([0-9]{4})([A-Z]{1})+$/,
                  max: 10,
                }"
              />
            </b-form-group>
          </b-col>
        </b-row>

        <!--  ID for Person-->
        <b-row style="max-width:1000px;" v-if="field.cus_type == 1">
          <b-col cols="12" lg="5" md="6" sm="8">
            <b-form-group label="Proof Type" label-for="cus_proof_id" class="mb-3">
              <select v-model="field.cus_proof_id" class="form-control">
                <option></option>
                <option value="1">Passport ID</option>
                <option value="2">Voter ID</option>
                <option value="3">Driving License ID</option>
              </select>
            </b-form-group>
          </b-col>
          <b-col cols="12" lg="5" md="6" sm="8" v-if="field.cus_proof_id">
            <b-form-group
              :label="'Proof No'"
              label-class="required"
              class="mb-3"
              label-for="cus_proof_no"
            >
              <b-form-input
                v-model="field.cus_proof_no"
                type="text"
                name="cus_proof_no"
                data-vv-name="proof no"
                v-validate="field.cus_proof_id ? 'required|max:50' : ''"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row style="max-width:1000px;">
          <b-col cols="12" lg="5" md="6" sm="8">
            <b-form-group
              :label="
                field.cus_currency != '99' && this.page == 'create'
                  ? 'Currency and Exchange Rate'
                  : 'Currency'
              "
              label-class="required"
              label-for="cus_currency"
            >
              <b-input-group :class="{ 'vselect-custom-add': field.is_used <= 0 }">
                <template slot="append" v-if="field.is_used <= 0">
                  <b-input-group-text
                    class="vselect-custom-add-icon"
                    v-b-modal.currencymodal
                    @click="
                      currency_detail = {
                        id: '',
                        code: '',
                        symbol: '',
                        name: '',
                        decimal_places: 2,
                        format: 1,
                      }
                    "
                  >&#43;</b-input-group-text>
                </template>
                <b-input-group-prepend :class="{ 'w-100': field.is_used > 0 && page == 'update' }">
                  <v-select
                    :clearable="false"
                    :disabled="field.is_used > 0"
                    id="search-select"
                    v-model.trim="field.cus_currency"
                    @input="getPriceListCurrency(field.pricing_hdr_id)"
                    name="currency"
                    data-vv-name="currency"
                    v-validate="'required'"
                    size="sm"
                    index="currency_id"
                    label="currency_name"
                    :options="currency_list"
                  />
                </b-input-group-prepend>
              </b-input-group>
              <input
                :disabled="field.is_used > 0"
                v-if="field.cus_currency != 99"
                type="text"
                name="customer currency"
                data-vv-name="customer currency"
                class="form-control mt-2"
                v-model="field.unit_currency"
                v-validate="'required|decimal:5'"
                @blur="roundOff('unit_currency', $event)"
              />
            </b-form-group>
          </b-col>
          <b-col cols="12" lg="5" md="6" sm="8">
            <b-form-group class="mb-3" label="Payment Terms" label-for="cus_pymnt_term">
              <v-select
                :clearable="false"
                data-vv-name="payment term"
                id="search-select"
                v-model.trim="field.cus_pymnt_term"
                name="pymnt_term"
                index="pymnt_terms_id"
                label="term_name"
                size="sm"
                :options="paymentterm"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row style="max-width:1000px;" class="my-4">
          <b-col
            cols="12"
            lg="5"
            md="6"
            sm="8"
            v-if="page == 'create'&&RoutePermission(false, '', '', 'settings', 'openingbalance')"
          >
            <b-form-group label="Opening Balance" label-for="opening_balance">
              <input
                @blur="roundOff('opening_balance', $event)"
                class="form-control"
                type="text"
                name="opening_balance"
                data-vv-name="Opening Balance"
                size="sm"
                v-model.trim="field.opening_balance"
                v-validate="'min_value:0|decimal:2'"
              />
            </b-form-group>
          </b-col>
          <b-col
            cols="12"
            lg="5"
            md="6"
            sm="8"
            v-if="
              price_list.length > 0 &&
                (enablepricelist.is_price_list_enabled == 1 ||
                  (page == 'update' && field.is_price_id_exist == '1'))
            "
          >
            <b-form-group class="mb-3" label="Price List" label-for="customer-tag-select">
              <v-select
                style="width:100%"
                label="label"
                index="value"
                data-vv-name="price list"
                class="float-left mb-3 form-vselect"
                id="search-select"
                v-model.trim="field.pricing_hdr_id"
                size="sm"
                :options="pricelistgenerate"
              >
                <template slot="option" slot-scope="option">
                  <div class="d-flex w-100 v-select-option" :title="option.label">
                    <div class="text-truncate" style="width:100%">{{ option.label }}</div>
                  </div>
                </template>
              </v-select>
            </b-form-group>
          </b-col>
          <b-col
            cols="12"
            lg="5"
            md="6"
            sm="8"
            v-if="
              cus_settings_details.cus_credit_limit &&
                cus_settings_details.cus_credit_limit.enable == 1
            "
          >
            <b-form-group class="mb-3" label-for="credit_limit" label="Credit Limit">
              <b-input-group
                :prepend="
                  getDetails(
                    $AppDetails.currency_details,
                    field.cus_currency || $AppDetails.organization.org_currency,
                    'currency_code'
                  )
                "
                class="mb-2 mr-sm-2 mb-sm-0 product_currency"
              >
                <b-input
                  data-vv-name="credit limit"
                  v-validate="'min_value:0|max_value:100000000000000'"
                  @blur="roundOff('credit_limit', $event)"
                  v-model.trim="field.credit_limit"
                  :class="{ 'form-control': true }"
                  type="text"
                />
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
      </b-collapse>
      <b-row style="max-width:1000px" class="mt-4 mb-2 pt-2">
        <b-col>
          <h6
            class="text-primary pr-2 py-2 fw-semi-bold h6-lg cursor_pointer"
            v-b-toggle.additional-details
          >
            Additional details
            <i class="fa fa-angle-down fw-semi-bold ml-1"></i>
          </h6>
        </b-col>
      </b-row>
      <b-collapse id="additional-details" visible>
        <b-row style="max-width:1000px;">
          <b-col cols="12" lg="5" md="6" sm="8">
            <b-form-group class="mb-3" label="Designation" label-for="designation">
              <b-form-input
                type="text"
                id="designation"
                v-model.trim="field.cus_dept"
                name="cus_dept"
                data-vv-name="designation"
                size="sm"
                v-validate="'min:2|max:50'"
              />
            </b-form-group>
          </b-col>
          <b-col cols="12" lg="5" md="6" sm="8">
            <b-form-group class="mb-3" label="Website" label-for="cus_website">
              <b-form-input
                type="text"
                data-vv-name="website"
                name="cus_website"
                size="sm"
                v-model.trim="field.cus_website"
                v-validate="'url'"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row style="max-width:1000px;" v-if="field.cus_type == 2">
          <b-col cols="12" lg="5" md="6" sm="8">
            <b-form-group label="Proof Type" label-for="cus_proof_id" class="mb-3">
              <select v-model="field.cus_proof_id" class="form-control">
                <option></option>
                <option value="1">Passport ID</option>
                <option value="2">Voter ID</option>
                <option value="3">Driving License ID</option>
              </select>
            </b-form-group>
          </b-col>
          <b-col cols="12" lg="5" md="6" sm="8" v-if="field.cus_proof_id">
            <b-form-group
              :label="'Proof No'"
              label-class="required"
              label-for="cus_proof_no"
              class="mb-3"
            >
              <b-form-input
                v-model="field.cus_proof_no"
                type="text"
                data-vv-name="proof no"
                name="cus_proof_no"
                v-validate="field.cus_proof_id ? 'required|max:50' : ''"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row style="max-width:1000px;">
          <b-col cols="12" lg="5" md="6" sm="8">
            <b-form-group label="Role" label-for="cus_role" class="mb-3">
              <b-form-input
                type="text"
                name="cus_role"
                data-vv-name="role"
                size="sm"
                v-model.trim="field.cus_role"
                v-validate="'min:3|max:50'"
              />
            </b-form-group>
          </b-col>
          <b-col cols="12" lg="5" md="6" sm="8">
            <b-form-group label="Facebook ID" label-for="cus_facebook_id" class="mb-3">
              <b-form-input
                data-vv-name="facebook id"
                name="cus_facebook_id"
                v-model.trim="field.cus_facebook_id"
                v-validate="'min:3|max:30'"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row style="max-width:1000px;">
          <b-col cols="12" lg="5" md="6" sm="8">
            <b-form-group label="Twitter ID" label-for="cus_twitter_id" class="mb-3">
              <b-form-input
                data-vv-name="twitter id"
                name="cus_twitter_id"
                v-model.trim="field.cus_twitter_id"
                v-validate="'max:30'"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <!-- <b-col cols="12" lg="5" md="6" sm="8">
            <b-form-group label="Legacy ID" label-for="cus_legacy_id" class="mb-3">
              <b-form-input
                type="text"
                data-vv-name="customer id"
                name="cus_legacy_id"
                size="sm"
                v-model.trim="field.cus_legacy_id"
                v-validate="'max:50|min:3'"
              />
            </b-form-group>
          </b-col>-->
          <b-col cols="12" lg="5" md="6" sm="8">
            <b-form-group label=" " label-for="checkbox_portal" class="mb-3 mt-4 pt-1">
              <b-form-checkbox
                :value="1"
                :unchecked-value="0"
                type="checkbox"
                id="cus_portal"
                name="cus_portal"
                data-vv-name="customer portal"
                v-model.trim="field.cus_portal"
                class="mr-2 cursor_pointer"
              >Enable Portal</b-form-checkbox>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row style="max-width:1000px;">
          <b-col cols="12" xs="12" sm="12" lg="10" class="mt-3">
            <b-form-group label="Customer Notes" label-for="customer-tag-select">
              <b-form-textarea
                id="note"
                v-model="field.cus_notes"
                data-vv-name="customer notes"
                name="cus_notes"
                rows="5"
                value
                v-validate="'min:3|max:250'"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </b-collapse>

      <b-row style="max-width:1000px" class="mt-4 mb-2 pt-2">
        <b-col>
          <h6
            class="text-primary pr-2 py-2 fw-semi-bold h6-lg cursor_pointer"
            v-b-toggle.address-details
          >
            Address details
            <i class="fa fa-angle-down fw-semi-bold ml-1"></i>
          </h6>
        </b-col>
      </b-row>
      <b-collapse id="address-details" visible>
        <b-row style="max-width:1000px;">
          <!-- Billing Address details tab -->
          <b-col cols="12" lg="5" md="6" sm="8">
            <fieldset class="mt-2">
              <p class="text-primary fw-semi-bold mb-3">Billing Address</p>
              <b-form-group label="Address Line 1" label-for="cus_billing_addr_line_1" class="mb-3">
                <b-form-input
                  type="text"
                  size="sm"
                  data-vv-name="billing address line 1"
                  name="cus_addr_line_1[]"
                  v-model.trim="field.cus_billing_addr_line_1"
                  v-validate="'max:200'"
                />
              </b-form-group>
              <b-form-group label="Address Line 2" label-for="cus_billing_addr_line_2">
                <b-form-input
                  type="text"
                  size="sm"
                  data-vv-name="billing address line 2"
                  name="cus_addr_line_2[]"
                  v-model.trim="field.cus_billing_addr_line_2"
                  v-validate="'max:200'"
                />
              </b-form-group>
              <b-form-group :label="'State'" label-for="cus_billing_state">
                <v-select
                  :clearable="false"
                  data-vv-name="billing state"
                  name="cus_billing_state"
                  id="search-select"
                  v-model.trim="field.cus_billing_state"
                  size="sm"
                  index="state_id"
                  label="state_name"
                  :options="$AppDetails.state_list"
                />
              </b-form-group>
              <b-form-group class="mb-3" label="City" label-for="cus_billing_city">
                <b-form-input
                  type="text"
                  size="sm"
                  data-vv-name="billing city"
                  name="cus_city[]"
                  v-model.trim="field.cus_billing_city"
                  v-validate="'max:30'"
                />
              </b-form-group>
              <b-form-group label="Country" label-for="cus_billing_country" class="mb-3">
                <v-select
                  :clearable="false"
                  id="search-select"
                  name
                  data-vv-name="billing country"
                  v-model.trim="field.cus_billing_country"
                  size="sm"
                  index="country_id"
                  label="country_name"
                  :options="$AppDetails.country_list"
                />
              </b-form-group>
              <b-form-group label="Pincode" label-for="cus_billing_pincode" class="mb-3">
                <b-form-input
                  type="text"
                  size="sm"
                  data-vv-name="pincode"
                  name="cus_pincode[]"
                  v-model.trim="field.cus_billing_pincode"
                  v-validate="'max:10'"
                />
              </b-form-group>
            </fieldset>
          </b-col>
          <b-col cols="12" lg="5" md="6" sm="8">
            <fieldset class="mt-2">
              <p class="text-primary fw-semi-bold mb-3">
                <b-row>
                  <b-col cols="6">Shipping Address</b-col>
                  <b-col cols="6" class="text-right">
                    <span
                      class="text-primary pb-1 mt-2"
                      @click="copyBilling()"
                      style="cursor:pointer"
                    >
                      <i class="fa fa-arrow-down"></i>
                      Copy billing address
                    </span>
                  </b-col>
                </b-row>
              </p>
              <b-form-group
                class="mb-3"
                label="Address Line 1"
                label-for="cus_shipping_addr_line_1"
              >
                <b-form-input
                  type="text"
                  size="sm"
                  data-vv-name="shipping address line 1"
                  name="cus_addr_line_1[]"
                  v-model.trim="field.cus_shipping_addr_line_1"
                  v-validate="'max:200'"
                />
              </b-form-group>
              <b-form-group
                label="Address Line 2"
                label-for="cus_shipping_addr_line_2"
                class="mb-3"
              >
                <b-form-input
                  type="text"
                  size="sm"
                  data-vv-name="shipping address line 2"
                  name="cus_addr_line_2[]"
                  v-model.trim="field.cus_shipping_addr_line_2"
                  v-validate="'max:200'"
                />
              </b-form-group>
              <b-form-group :label="'State'" label-for="cus_shipping_state" class="mb-3">
                <v-select
                  :clearable="false"
                  id="search-select"
                  name="cus_shipping_state"
                  v-model.trim="field.cus_shipping_state"
                  size="sm"
                  index="state_id"
                  label="state_name"
                  data-vv-name="shipping state"
                  :options="$AppDetails.state_list"
                />
              </b-form-group>
              <b-form-group label="City" label-for="cus_shipping_city" class="mb-3">
                <b-form-input
                  type="text"
                  size="sm"
                  data-vv-name="shipping city"
                  name="cus_city[]"
                  v-model.trim="field.cus_shipping_city"
                  v-validate="'max:30'"
                />
              </b-form-group>
              <b-form-group label="Country" label-for="cus_shipping_country" class="mb-3">
                <v-select
                  :clearable="false"
                  id="search-select"
                  data-vv-name="shipping country"
                  v-model.trim="field.cus_shipping_country"
                  size="sm"
                  index="country_id"
                  label="country_name"
                  :options="$AppDetails.country_list"
                />
              </b-form-group>
              <b-form-group label="Pincode" label-for="cus_shipping_pincode" class="mb-3">
                <b-form-input
                  type="text"
                  size="sm"
                  data-vv-name="shipping pincode"
                  name="cus_pincode[]"
                  v-model.trim="field.cus_shipping_pincode"
                  v-validate="'max:10'"
                />
              </b-form-group>
            </fieldset>
          </b-col>
        </b-row>
      </b-collapse>

      <b-row style="max-width:1000px" class="mt-4 mb-2 pt-2">
        <b-col>
          <h6
            class="text-primary pr-2 py-2 fw-semi-bold h6-lg cursor_pointer"
            v-b-toggle.reporting-tags
          >
            Reporting Tags
            <i class="fa fa-angle-down fw-semi-bold ml-1"></i>
          </h6>
        </b-col>
      </b-row>
      <b-collapse id="reporting-tags" visible>
        <b-row style="max-width:1000px;">
          <!-- Billing Address details tab -->
          <b-col v-if="reporting_tags.length==0">
            <p class="text-muted">You've not created any Reporting Tags.</p>
          </b-col>
          <b-col
            v-else-if="reporting_tags.filter(tag=>(tag.status==='0'&&field[tag.tag_column_name]!='')||tag.status==='1').length==0"
          >
            <p
              class="text-muted"
            >There are no active reporting tags or you've not created a reporting tag yet.You can create/edit reporting tags under settings</p>
          </b-col>
          <template v-else>
            <b-col
              cols="12"
              lg="5"
              md="6"
              sm="8"
              v-for="(tag,index) in reporting_tags"
              :key="index"
              v-if="tag.status === '1' ||show_reporting_tag[index].used"
            >
              <b-form-group
                :label-for="'tag field' +index"
                :label="tag.tag_name"
                label-class="text-truncate"
                v-if="tag.tag_options.filter(x=>(x.is_active==false&&show_reporting_tag[index][tag.tag_column_name]==x.value)||x.is_active).length>0"
              >
                <v-select
                  :clearable="field[tag.tag_column_name]!=''&&field[tag.tag_column_name]!=null"
                  @input="$event==null?field[tag.tag_column_name]='':''"
                  v-model="field[tag.tag_column_name]"
                  index="value"
                  label="label"
                  :options="tag.tag_options.filter(x=>(x.is_active==false&&show_reporting_tag[index][tag.tag_column_name]==x.value)||x.is_active)"
                  class="form-vselect"
                >
                  <template slot="option" slot-scope="option">
                    <div class="d-flex w-100 v-select-option" :title="option.label">
                      <div class="text-truncate" style="width:100%">{{ option.label }}</div>
                    </div>
                  </template>
                </v-select>
              </b-form-group>
            </b-col>
          </template>
        </b-row>
      </b-collapse>

      <b-row style="max-width:1000px" class="mt-4 mb-2 pt-2">
        <b-col>
          <h6
            class="text-primary pr-2 py-2 fw-semi-bold h6-lg cursor_pointer"
            v-b-toggle.contact-details
          >
            Contact details
            <i class="fa fa-angle-down fw-semi-bold ml-1"></i>
          </h6>
        </b-col>
      </b-row>
      <b-collapse id="contact-details" visible>
        <b-row style="max-width:1000px">
          <b-col xl="12" lg="12" md="12" sm="12" xs="12" class="pr-1">
            <div class="table-responsive">
              <table class="table table-bordered sales-table last-child-border-none">
                <thead>
                  <!-- <th style="width:10px">#</th> -->
                  <th>First Name</th>
                  <th>Last Name</th>
                  <th>Work Phone</th>
                  <th>Mail</th>
                  <th>Designation</th>
                  <th>Department</th>
                  <th></th>
                </thead>

                <tbody>
                  <tr v-for="(item, index) in items" :key="index">
                    <td>
                      <b-form-input
                        class="in-bdr"
                        id="contact_fname"
                        v-model.trim="item.cntct_fname"
                        type="text"
                        size="sm"
                        data-vv-name="contact first name"
                        :name="'cntct_fname[' + index + ']'"
                        style="border: none; padding:5px;"
                        v-validate="'max:30'"
                      />
                    </td>
                    <td>
                      <b-form-input
                        id="cntct_lname"
                        v-model.trim="item.cntct_lname"
                        type="text"
                        data-vv-name="contact last name"
                        size="sm"
                        :name="'cntct_lname[' + index + ']'"
                        style="border: none; padding:5px;"
                        v-validate="'max:30'"
                      />
                    </td>
                    <td>
                      <b-form-input
                        id="cntct_no"
                        v-model.trim="item.cntct_no"
                        type="text"
                        size="sm"
                        data-vv-name="contact no"
                        :name="'cntct_no[' + index + ']'"
                        style="border: none; padding:5px;"
                        v-validate="'phone: true'"
                      />
                    </td>
                    <td>
                      <b-form-input
                        id="cntct_mail"
                        v-model.trim="item.cntct_mail"
                        type="text"
                        size="sm"
                        data-vv-name="contact email"
                        :name="'cntct_mail[' + index + ']'"
                        style="border: none; padding:5px;"
                        v-validate="'email:true'"
                      />
                    </td>
                    <td>
                      <b-form-input
                        id="cntct_role"
                        v-model.trim="item.cntct_role"
                        type="text"
                        size="sm"
                        data-vv-name="contact designation"
                        style="border: none; padding:5px;"
                        :name="'cntct_role[' + index + ']'"
                        v-validate="'max:50'"
                      />
                    </td>
                    <td>
                      <b-form-input
                        id="cntct_dept"
                        v-model.trim="item.cntct_dept"
                        type="text"
                        size="sm"
                        data-vv-name="contact department"
                        style="border: none; padding:5px;"
                        :name="'cntct_dept[' + index + ']'"
                        v-validate="'max:50'"
                      />
                    </td>
                    <td>
                      <b-form-group class="text-center">
                        <span>
                          <i class="glyphicon glyphicon-trash mt-2" @click="removeRow(index)"></i>
                        </span>
                      </b-form-group>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <b-col xl="12" md="12" lg="12" sm="12" xs="12" class="pl-0">
              <span class="text-link fw-semi-bold" @click="addNewRow()">Add Lines</span>
            </b-col>
          </b-col>
        </b-row>
      </b-collapse>

      <template v-if="cus_settings_details.custom_field.length > 0">
        <b-row style="max-width:1000px" class="mt-4 mb-2 pt-2">
          <b-col>
            <h6
              class="text-primary pr-2 py-2 fw-semi-bold h6-lg cursor_pointer"
              v-b-toggle.custom-fields
            >
              Custom fields
              <i class="fa fa-angle-down fw-semi-bold mr-1"></i>
            </h6>
          </b-col>
        </b-row>
        <b-collapse id="custom-fields" visible>
          <b-row style="max-width:1000px;">
            <b-col
              cols="12"
              lg="5"
              md="6"
              sm="8"
              :key="index"
              v-for="(custom_field, index) in cus_settings_details.custom_field"
              v-if="custom_field.status == 1 && custom_field.permissions == 'write'"
            >
              <CustomPreview
                v-on:assigncustomvalue="assigncustomvalue($event)"
                :custom="custom_field"
                :disabled="false"
                :modelname="field[custom_field.field_name]"
              />
              <input
                type="hidden"
                :name="custom_field.label_name"
                v-validate="custom_field.validation"
                v-model="field[custom_field.field_name]"
              />
            </b-col>
          </b-row>
        </b-collapse>
      </template>
      <b-row style="max-width:1000px" class="mt-4 mb-2 pt-2">
        <b-col>
          <h6 class="text-primary pr-2 py-2 fw-semi-bold h6-lg cursor_pointer" v-b-toggle.remarks>
            Remarks
            <i class="fa fa-angle-down fw-semi-bold ml-1"></i>
          </h6>
        </b-col>
      </b-row>
      <b-collapse id="remarks" visible>
        <b-row style="max-width:1000px">
          <b-col cols="12" lg="10">
            <b-form-group label="Remarks" label-for="cus_internal_notes">
              <b-form-textarea
                id="note"
                v-model="field.cus_internal_notes"
                name="cus_internal_notes"
                data-vv-name="customer remarks"
                rows="5"
                value
                v-validate="'min:3|max:250'"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </b-collapse>
      <!-- End Skype  and website no for customer update -->
      <div class="footer" style="box-shadow:0 -4px 5px -3px #ccc;">
        <div class="form-action" style="background:none !important;">
          <b-button
            type="submit"
            size="sm"
            variant="primary"
            class="btn-rounded mr-3"
            :disabled="submitted"
          >
            <i v-if="submitted" class="fa fa-circle-o-notch fa-spin mr-2"></i>Save
          </b-button>
        </div>
      </div>
    </b-form>
    <!-- page header for customer update -->

    <TagModal
      v-if="customertags"
      :tag_id="modal_tag_id"
      module="customer"
      v-on:setMultipleAddedRef="getMultipleAddedRef"
    ></TagModal>
    <DeleteDropdown
      v-if="customerdeletetag||excemptdelete"
      id="customer-dropdown-delete"
      content="Are you sure to delete the selected detail ?"
      module="general"
      method="exemptreasondelete"
      v-on:setDropdownDelete="getDropdownDelete"
      :value="deletedropdownid"
    ></DeleteDropdown>
    <!-- create and update currency modal -->
    <CurrencyModal
      :page="'create'"
      :currency_detail="currency_detail"
      @addedCurrency="field.cus_currency = $event"
    ></CurrencyModal>

    <ExemptReason
      v-if="excemptmodal"
      :exempt_reason="modal_exempt_reason"
      module="customer"
      v-on:setMultipleAddedRefExempt="getMultipleAddedRefExempt"
    ></ExemptReason>
    <b-modal
      :no-close-on-backdrop="true"
      id="duplicateModal"
      size="md"
      ref="duplicateModal"
      body-class="bg-white"
      cancel-title="Cancel"
      cancel-variant="light"
      ok-title="Go to Settings"
      @ok="GoSettings"
      v-model="duplicate_modal"
      :hide-header="true"
    >
      <b-form>
        <b-form-group>
          <b-row>
            <b-col lg="12">
              <p class="text-muted mt-3">
                <i class="fa fa-exclamation-circle fa-lg text-warning mr-1"></i> The Contact Name
                <span class="fw-semi-bold text-dark">{{field.cus_display_name}}</span> already exists. Your current settings does not allow you to create duplicate contact names. You can change the settings to allow this or specify a different name.
              </p>
            </b-col>
          </b-row>
        </b-form-group>
      </b-form>
    </b-modal>
  </div>
</template>
<script>
import CustomPreview from "@/components/Form/Settings/CustomPreview";
import { mapState, mapGetters } from "vuex"; // to accss state from all the vuex file
import TagModal from "@/components/Modal/TagModal"; // call tag form form another tag componen
import vSelect from "vue-select"; // vue seatch select component
import DeleteDropdown from "@/components/Modal/DeleteDropdown";
import $ from "jquery";
import CurrencyModal from "@/components/Modal/Currency/CurrencyModal"; // to excel export the output
import ExemptReason from "@/components/Modal/ExemptReason";

export default {
  props: ["page", "submitted"],
  name: "customer",
  components: {
    DeleteDropdown,
    CustomPreview,
    vSelect, // vue search select dropdwon
    TagModal, // tag form form modal
    CurrencyModal,
    ExemptReason
  },
  data() {
    // data details for customer create
    return {
      duplicate_modal: false,
      show_reporting_tag: [],
      old_cus_cntct_ids: "",
      FormUpdate: 0,
      customertags: false,
      excemptdelete: false,
      customerdeletetag: false,
      checked: false,
      error_show: false, // hide the validation error message
      modal_tag_id: {},
      text: "",
      checkboxes1: "",
      updatetag: false,
      deletedropdownid: "",
      modal_exempt_reason: "",
      excemptmodal: false,
      taxable_preference: [
        // radio button for taxable preferance
        {
          text: "Taxable",
          value: "0"
        },
        {
          text: "Tax Exempt",
          value: "1"
        }
      ],
      cus_type: [
        // radio button for customer type
        {
          text: "Person",
          value: "1"
        },
        {
          text: "Organization",
          value: "2"
        }
      ],
      field: this.createFreshEventObject(), // refresh the fields
      items: [
        // data for contact fields
        {
          cntct_fname: "",
          cntct_lname: "",
          cntct_no: "",
          cntct_mail: "",
          cntct_role: "",
          cntct_dept: ""
        }
      ],
      currency_detail: {
        id: "",
        code: "",
        symbol: "",
        name: "",
        decimal_places: 2,
        format: 1
      },
      excemptdelete: false
    };
  },
  methods: {
   redirectPage() {
      if (this.$route.query.page_from == "view"&&(this.$route.params.id||this.$route.query.clone_id||this.$route.query.old_id)) {     
          this.$router.push({
            name: "CustomerView",
            params: { id: this.$route.params.id||this.$route.query.clone_id||this.$route.query.old_id },
          });
      } else {
        if (this.$store.state.customer.cus_index_history) {
          this.$router.push(this.$store.state.customer.cus_index_history);
        } else {
          this.$router.push({ name: "Customer" });
        }
      }
    },

    OpenSettingsModal() {
      this.duplicate_modal = true;
    },
    GoSettings() {
      this.$router.push({
        name: "CustomerStatement"
      });
    },
    getMultipleAddedRefExempt(ev) {
      if (ev.close) {
        this.excemptmodal = false;
        return;
      }

      this.field.exempt_reason = "";
      this.field.exempt_reason = this.updatedtag_id;
    },
    callexemptmodal(val) {
      this.$nextTick(() => {
        this.$root.$emit("bv::show::modal", "addexempt");
        this.modal_exempt_reason = val;
      });
    },
    getPriceListCurrency(val) {
      if (this.enablepricelist.is_price_list_enabled != 1) {
        var index = this.pricelistgenerate.findIndex(x => x.value == val);
        this.field.pricing_currency_id = this.pricelistgenerate[
          index
        ].currency_id;
      }
    },

    updateFields() {
      var main_detail = this.list.data.main_detail;
      var cntct_detail = this.list.data.cntct_detail;
      var billing_addr_detail = this.list.data.billing_address[0];
      var shipping_addr_detail = this.list.data.shipping_address[0];
      var main_fields = this.field;
      this.old_cus_cntct_ids = this.list.data.old_cus_cntct_ids;
      this.field.is_price_id_exist = main_detail.is_price_id_exist;

      // main details
      this.field.cus_fname = main_detail.cus_fname;
      this.field.is_used = main_detail.is_used;
      this.field.opening_balance = main_detail.opening_balance;
      this.field.place_of_supply = main_detail.place_of_supply;
      this.field.cus_lname = main_detail.cus_lname;
      this.field.cus_notes = main_detail.cus_notes;
      this.field.pricing_hdr_id = main_detail.pricing_hdr_id;
      this.field.cus_comp = main_detail.cus_comp_name;
      this.field.cus_mail = main_detail.cus_mail;
      this.field.cus_ph_no_1 = main_detail.cus_ph_no_1;
      this.field.cus_type = main_detail.cus_type;
      this.field.cus_dept = main_detail.cus_dept;
      this.field.cus_display_name = main_detail.cus_display_name;
      this.field.credit_limit = main_detail.credit_limit;
      this.field.cus_tax_exempt = main_detail.cus_tax_exempt;
      this.field.cus_website = main_detail.cus_website;
      this.field.cus_role = main_detail.cus_role;
      this.field.cus_legacy_id = main_detail.cus_legacy_id;
      this.field.unit_currency = main_detail.unit_currency;
      this.field.exempt_reason = main_detail.exemptreason_id;
      //billing address details
      this.field.cus_billing_addr_line_1 = billing_addr_detail.cus_addr_line_1;
      this.field.cus_billing_addr_line_2 = billing_addr_detail.cus_addr_line_2;
      this.field.cus_billing_state = billing_addr_detail.cus_state;
      this.field.cus_billing_city = billing_addr_detail.cus_city;
      for (var i = 0; i < this.cus_settings_details.custom_field.length; i++) {
        this.field[this.cus_settings_details.custom_field[i].field_name] =
          main_detail[this.cus_settings_details.custom_field[i].field_name];
      }
      //update to fields for reporting tag field values
      for (var i = 0; i < this.reporting_tags.length; i++) {
        this.show_reporting_tag.push({
          used:
            main_detail[this.reporting_tags[i].tag_column_name] != "" &&
            main_detail[this.reporting_tags[i].tag_column_name] != null
              ? true
              : false,
          [this.reporting_tags[i].tag_column_name]:
            main_detail[this.reporting_tags[i].tag_column_name]
        });
        this.field[this.reporting_tags[i].tag_column_name] = main_detail[
          this.reporting_tags[i].tag_column_name
        ]
          ? parseInt(main_detail[this.reporting_tags[i].tag_column_name])
          : "";
      }
      // this.field.cus_billing_country = billing_addr_detail.cus_country;
      this.field.cus_billing_pincode = billing_addr_detail.cus_pincode;
      //shipping address details
      this.field.cus_shipping_addr_line_1 =
        shipping_addr_detail.cus_addr_line_1;
      this.field.cus_shipping_addr_line_2 =
        shipping_addr_detail.cus_addr_line_2;
      this.field.cus_shipping_state = shipping_addr_detail.cus_state;
      this.field.cus_shipping_city = shipping_addr_detail.cus_city;
      // this.field.cus_shipping_country = shipping_addr_detail.cus_country;
      this.field.cus_shipping_pincode = shipping_addr_detail.cus_pincode;
      // contact details values
      this.items = cntct_detail;
      // all the dropdown values

      if (main_detail.cus_currency != null) {
        this.field.cus_currency = main_detail.cus_currency;
      }
      if (shipping_addr_detail.cus_country != null) {
        this.field.cus_shipping_country = shipping_addr_detail.cus_country;
      }

      if (billing_addr_detail.cus_country != null) {
        this.field.cus_billing_country = billing_addr_detail.cus_country;
      }
      if (shipping_addr_detail.cus_state != null) {
        this.field.cus_shipping_state = shipping_addr_detail.cus_state;
      }
      if (main_detail.place_of_supply != null) {
        this.field.place_of_supply = main_detail.place_of_supply;
      }
      if (billing_addr_detail.cus_state != null) {
        this.field.cus_billing_state = billing_addr_detail.cus_state;
      }

      $.each(this.$AppDetails.gst_type_list, function(key, value) {
        if (value.gst_type_id == main_detail.cus_gst_type) {
          main_fields.cus_gst_type = value.gst_type_id;
        }
      });
      $.each(this.paymentterm, function(key, value) {
        if (value.pymnt_terms_id == main_detail.cus_pymnt_term) {
          main_fields.cus_pymnt_term = value.pymnt_terms_id;
        }
      });
      this.field.cus_tags = main_detail.cus_tags;
      //general details
      this.field.cus_portal = main_detail.cus_portal == 1 ? 1 : "";
      this.field.cus_gst_no = main_detail.cus_gst_no;
      this.field.cus_pan_no = main_detail.cus_pan_no;
      this.field.cus_twitter_id = main_detail.cus_twitter_id;
      this.field.cus_facebook_id = main_detail.cus_facebook_id;
      this.field.cus_internal_notes = main_detail.cus_internal_notes;
      this.field.cus_proof_id = main_detail.cus_proof_id;
      this.field.cus_proof_no = main_detail.cus_proof_no;
      this.field.is_whatsapp_no = main_detail.is_whatsapp_no;
    },
    //    roundoff paid amount
    roundOff(field) {
      this.field[field] =
        typeof this.field[field] != undefined &&
        !isNaN(this.field[field]) &&
        this.field[field] != ""
          ? parseFloat(this.field[field]) <= 0 && field == "credit_limit"
            ? ""
            : parseFloat(this.field[field]).toFixed(2)
          : field == "credit_limit"
          ? ""
          : parseFloat(0).toFixed(2);
    },
    //  assign custom value
    assigncustomvalue(ev) {
      this.field[ev.field] = ev.value;
    },
    //get pan no
    getPanState(val) {
      this.field.cus_pan_no = val.substr(2, 10);
      //get source supply no
      val = val.substr(0, 2);
      var isNum = /^\d+$/.test(val);
      if (isNum) {
        val = parseInt(val);
        if ((val > 0 && val <= 37) || val == 97) {
          this.field.place_of_supply = val.toString();
        }
      }
    },

    //  call delete dropdown modal
    calldeletemodal(val) {
      this.$nextTick(() => {
        this.$root.$emit("bv::show::modal", "customer-dropdown-delete");
        this.deletedropdownid = val;
      });
    },
    //  to get the json particular value
    getPresentValue(arr, prop, val, field) {
      var hasMatch = "";
      for (var i = 0; i < arr.length; i++) {
        if (arr[i][prop] == val) {
          hasMatch = arr[i][field];
          // alert(hasMatch);
          break;
        }
      }
      return hasMatch;
    },
    getDropdownDelete(ev) {
      if (ev.close) {
        this.customerdeletetag = false;
        this.excemptdelete = false;
        return;
      }
      if (ev == 200) {
        if (this.method == "exemptdelete") {
          var id = this.getPresentValue(
            this.exempt_reason_list,
            "label",
            ev.label,
            "value"
          );
          this.excemptdelete = false;
          this.field.exempt_reason = id;
        }
        // if (this.field.cus_tags != []) {
        //   var index = this.field.cus_tags.indexOf(this.deletedropdownid);
        //   if (index != -1) {
        //     this.field.cus_tags.splice(index, 1);
        //     this.deletedropdownid = "";
        //   }
        // }
      }
    },
    //  add the newly added fields
    getMultipleAddedRef(ev) {
      if (ev.close) {
        this.customertags = false;
        return;
      }
      var value = this.updatedtag_id;
      if (this.updatetag != true) {
        this.field.cus_tags.push(value);
      }
    },
    // on click copy billing duplicate the billing to shipping address
    copyBilling() {
      this.field.cus_shipping_addr_line_1 = this.field.cus_billing_addr_line_1;
      this.field.cus_shipping_addr_line_2 = this.field.cus_billing_addr_line_2;
      this.field.cus_shipping_state = this.field.cus_billing_state;
      this.field.cus_shipping_city = this.field.cus_billing_city;
      this.field.cus_shipping_country = this.field.cus_billing_country;
      this.field.cus_shipping_pincode = this.field.cus_billing_pincode;
    },
    //show the tag modal to add tags dynamically
    calltagmodal(val) {
      this.$nextTick(() => {
        this.$root.$emit("bv::show::modal", "addTag");
        this.modal_tag_id = val;
      });
    },

    //chekck gst type to show gst no or pan no fields

    onSubmit(scope) {
      this.$validator.validateAll(scope).then(result => {
        if (result) {
          //  send the json data
          // this.errors.items = this.this.message;

          let data = JSON.stringify({
            id: this.$route.params.id,
            field: this.field,
            items: this.items,
            old_cus_cntct_ids: this.old_cus_cntct_ids
          });
          this.$emit("onSubmit", {
            data: data
          });
        } else {
          // Scroll to error message show
          var content = $(".container-fluid");
          content[0].scrollIntoView(false);
          this.error_show = true; // validate the form if fail
        }
      });
      return false;
    },
    // to add line new row
    addNewRow() {
      this.items.push({}); // to clone the existing row
    },
    // remove the added table
    removeRow(index) {
      if (this.items.length > 1) {
        // dont delete the first row
        this.items.splice(index, 1);
      }
    },
    // to refresh the fields as empty
    createFreshEventObject() {
      return {
        pricing_hdr_id: null,
        unit_currency: 1,
        opening_balance: 0.0,
        cus_notes: "",
        cus_tags: [],
        cus_legacy_id: "",
        cus_fname: "",
        cus_lname: "",
        cus_comp: "",
        cus_mail: "",
        cus_ph_no_1: "",
        cus_tax_exempt: 0,
        cus_dept: "",
        cus_display_name: "",
        cus_gst_no: "",
        cus_billing_addr_line_1: "",
        cus_billing_addr_line_2: "",
        cus_billing_state: "",
        cus_billing_city: "",
        cus_billing_country: "",
        cus_billing_pincode: "",
        cus_shipping_addr_line_1: "",
        cus_shipping_addr_line_2: "",
        cus_shipping_state: "",
        cus_shipping_city: "",
        cus_shipping_country: "",
        cus_shipping_pincode: "",
        cus_type: 1,
        cus_role: "",
        cus_website: "",
        place_of_supply: "",
        cus_internal_notes: "",
        cus_billing_addr_type: 1,
        cus_shipping_addr_type: 2,
        cus_currency: "99",
        cus_pymnt_term: "7",
        cus_portal: "",
        cus_pan_no: "",
        cus_gst_type: "5",
        cus_proof_id: "",
        cus_proof_no: "",
        is_whatsapp_no: "",
        credit_limit: "",
        is_used: 0,
        exempt_reason: ""
      };
    }
  },
  // called synchronously after the vue instance created
  async created() {
    if (
      this.org_details.org_state != "" &&
      this.org_details.org_state != null
    ) {
      this.field.place_of_supply = this.org_details.org_state;
    }
    //update to fields for reporting tag field values
    for (var i = 0; i < this.reporting_tags.length; i++) {
      this.$set(this.field, this.reporting_tags[i].tag_column_name, "");
    }
    for (var i = 0; i < this.cus_settings_details.custom_field.length; i++) {
      if (
        this.cus_settings_details.custom_field[i].status == 1 &&
        this.cus_settings_details.custom_field[i].permissions == "write"
      ) {
        this.$set(
          this.field,
          this.cus_settings_details.custom_field[i].field_name,
          this.cus_settings_details.custom_field[i].default_value
        );
      }
    }
    if (this.page == "update" || this.$route.query.clone_id) {
      await this.updateFields();
    } else {
      //update to fields for reporting tag field values
      for (var i = 0; i < this.reporting_tags.length; i++) {
        this.show_reporting_tag.push({
          used: "",
          [this.reporting_tags[i].tag_column_name]: ""
        });
        this.$set(this.field, this.reporting_tags[i].tag_column_name, "");
      }
    }

    // to get the messenger notification in pretty format

    //  to watch any updates in details data
    this.$watch(
      "field",
      function() {
        this.FormUpdate = 1;
      },
      {
        deep: true
      }
    );
    //  to watch any updates in details data
    this.$watch(
      "items",
      function() {
        this.FormUpdate = 1;
      },
      {
        deep: true
      }
    );
  },
  watch: {
    checkgsttype: {
      deep: true,
      handler: function(val) {
        if (val == false) {
          this.field.cus_gst_no = "";
        }
      }
    }
  },
  computed: {
    pricelistgenerate() {
      var pricelist = [];
      var field = this.field;
      this.price_list.map(value => {
        if (this.enablepricelist.is_price_list_enabled == 1) {
          if (
            (value.status == 1 ||
              (value.status == 0 && value.value == field.pricing_hdr_id)) &&
            (value.pricing_type == "fixed_percentage" ||
              ((this.org_details.org_currency == value.currency_id ||
                this.field.cus_currency == value.currency_id) &&
                value.pricing_type == "per_item"))
          ) {
            pricelist.push(value);
          } else if (value.value == field.pricing_hdr_id) {
            field.pricing_hdr_id = null;
          }
        } else if (value.value == field.pricing_hdr_id) {
          pricelist.push(value);
        }
      });

      return pricelist;
    },
    checkgsttype() {
      var cus_gst_type =
        typeof this.field.cus_gst_type != "undefined" &&
        this.field.cus_gst_type != null
          ? this.field.cus_gst_type
          : 0;

      return cus_gst_type != "3" && cus_gst_type != "5" && cus_gst_type != "6";
    },
    // to get the required data from the vuex state
    ...mapState({
      list: state => state.customer.list,
      enablepricelist: state => state.permission.price_list,
      paymentterm: state => state.customer.paymentterm, // get the payment term to show in drop down
      currency: state => state.customer.currency, // get the currency list to show in dropdown
      price_list: state => state.customer.price_list, // get the price list to show in dropdown
      customertaglist: state => state.customer.customertaglist, // get the customer tag o show in dropdown
      org_state: state => state.sales.org_state,
      currency_list: state => state.customer.currency_list,
      updatedtag_id: state => state.customer.updatedtag_id,
      exempt_reason_list: state => state.customer.exempt_detail //get exempt reason in dropdown
    }),
    ...mapGetters(["org_details", "cus_settings_details", "reporting_tags"])
  }
};
</script>
<style>
.table-bordered.clg-tabl th {
  background-color: #ededed;
}

.table.pad-tabl td {
  padding: 2px 2px 2px 5px !important;
}

.frm-act .form-action {
  background-color: none;
  margin: 0px;
  padding: 10px;
}

legend.bodr-btm {
  border-bottom: none;
}

.nav-cols .tab-content > .tab-pane {
  padding-left: 0px;
}

.nav-cols .nav-tabs {
  background-color: #fff !important;
}

.nav-cols .nav-tabs .nav-link.active {
  background-color: #ededed !important;
  color: #29323a !important;
}
</style>
